module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/tutorials-examples-microwave.json
// module id = 820
// module chunks = 15480069851703